import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=b8bc05c4&scoped=true&"
import script from "./AreaChart.vue?vue&type=script&lang=js&"
export * from "./AreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bc05c4",
  null
  
)

export default component.exports